import { render, staticRenderFns } from "./CustomerRoiData.vue?vue&type=template&id=79675024&"
import script from "./CustomerRoiData.vue?vue&type=script&lang=js&"
export * from "./CustomerRoiData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports